var _path, _path2, _ellipse, _path3, _path4, _path5, _polygon, _path6, _path7, _circle, _path8, _path9, _path0, _polygon2, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _circle2, _polygon3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTip7(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ac21ac2c-fe4f-4034-a272-ff155c287926",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 796,
    height: 520.76018,
    viewBox: "0 0 796 520.76018",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "download_files") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M267.16612,576.7252l-5.96775-23.538a305.64288,305.64288,0,0,0-32.42712-11.63385l-.75353,10.939L224.96227,540.441C211.29669,536.5387,202,534.81983,202,534.81983s12.55769,47.753,38.89653,84.26083l30.69053,5.391-23.84262,3.43767a123.65623,123.65623,0,0,0,10.66514,11.30231c38.31558,35.565,80.99191,51.88249,95.32029,36.446s-5.11711-56.78141-43.43269-92.34646c-11.8782-11.02551-26.79975-19.87339-41.73613-26.83685Z",
    transform: "translate(-202 -189.61991)",
    fill: "#e6e6e6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M323.92413,551.16351l7.05814-23.23429a305.64577,305.64577,0,0,0-21.74551-26.72073l-6.29946,8.97482,3.61382-11.896C296.86985,487.88308,289.8,481.60617,289.8,481.60617S275.86629,528.976,279.54259,573.8429l23.48586,20.4789-22.18729-9.38149a123.65712,123.65712,0,0,0,3.28766,15.18812c14.41624,50.25065,42.51459,86.27857,62.75948,80.47058s24.96991-51.25248,10.55368-101.50313c-4.46918-15.5782-12.66921-30.86535-21.856-44.547Z",
    transform: "translate(-202 -189.61991)",
    fill: "#e6e6e6"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 398,
    cy: 498.9616,
    rx: 398,
    ry: 21.79858,
    fill: "#e6e6e6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M442.04855,542.49064s105.67777-46.74209,116.51652-13.54843-69.77443,88.74223-69.77443,88.74223l-33.87108-9.4839,46.06467-33.87108s-63.00021,44.70983-94.839,34.5485-46.74209-38.613-46.74209-38.613Z",
    transform: "translate(-202 -189.61991)",
    fill: "#2f2e41"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M489.46807,612.94249l-14.22586,25.0646s4.74195,29.80655,18.96781,33.19366,23.70975,12.871,12.19359,14.90328-40.6453,4.06453-45.38725-6.0968-16.25812-28.45171-16.25812-28.45171l2.70969,24.38718-13.54844.67742-2.03226-27.77428a19.09048,19.09048,0,0,1,3.38711-17.613c6.77421-8.80649,26.44878-26.0274,26.44878-26.0274Z",
    transform: "translate(-202 -189.61991)",
    fill: "#2f2e41"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M338.42742,592.45267a2.24958,2.24958,0,0,0-2.30191,2.18821v85.775a2.24959,2.24959,0,0,0,2.30191,2.18822H443.81993a2.24959,2.24959,0,0,0,2.30191-2.18822v-85.775a2.24958,2.24958,0,0,0-2.30191-2.18821Z",
    transform: "translate(-202 -189.61991)",
    fill: "#e6e6e6"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "268.162 215.015 201.069 221.012 180.665 165.412 239.264 151.296 268.162 215.015",
    fill: "#2f2e41"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M391.24193,562.13587s106.35519-3.38711,89.41965,37.25819-75.87122,41.32272-75.87122,41.32272l-13.54843,9.4839s-18.29038-10.83875-17.613-28.45171l22.35491-9.4839s-50.80662,27.77429-56.90341-10.83875S391.24193,562.13587,391.24193,562.13587Z",
    transform: "translate(-202 -189.61991)",
    fill: "#2f2e41"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M379.72576,622.42639S330.6127,624.12,333.99981,639.70065s-3.0484,43.01627-3.0484,43.01627l11.51617,4.06453,3.3871-23.70976s2.70969,35.90335,17.613,36.58077,46.06466,6.77421,45.38724,0-24.38717-20.32265-24.38717-20.32265l-1.35485-23.70976,8.12906-10.16132Z",
    transform: "translate(-202 -189.61991)",
    fill: "#2f2e41"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 214.98395,
    cy: 182.16049,
    r: 31.16139,
    fill: "#9f616a"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M391.24193,377.19977s-.67742,27.77429-17.613,31.16139-13.20972,19.30652-13.20972,19.30652l28.79042,36.91948L425.113,425.2967l3.38711-14.22585s-14.90328,6.0968-11.51617-2.70969a106.37079,106.37079,0,0,0,4.742-15.58069Z",
    transform: "translate(-202 -189.61991)",
    fill: "#9f616a"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M389.59813,423.69032c-1.63519-3.772-4.69493-9.20817-10.21108-17.02271,0,0-54.53244,9.14519-47.75822,56.56471s8.80648,81.29059,8.80648,81.29059-.02587.07292-.07625.21738c-5.24885,15.05215-7.99407,33.38213-4.327,48.89569,2.13285,9.023,3.72582,12.5323,3.72582,12.5323s-1.35484-36.58077,56.90341-42.00014,53.855-29.46784,53.855-29.46784l-9.4839-117.19394c-.18477-4.20363,1.49737-10.0885-2.70969-10.16133-8.9233-.15446-16.79887-1.25382-21.33878,1.01613-5.0835,2.54175.13284,16.1463-10.115,21.63377A12.52086,12.52086,0,0,1,389.59813,423.69032Z",
    transform: "translate(-202 -189.61991)",
    fill: "#3f3d56"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M439.97368,332.59634s14.04154,4.68052,14.91793,23.11045a33.30428,33.30428,0,0,1-.97206,9.21651c-.80565,3.41441-1.3216,10.78807,5.015,20.41949a190.12149,190.12149,0,0,1,11.278,19.43674h0l-15.60718,1.9509-3.31861-25.87a128.82239,128.82239,0,0,0-10.22967-36.31784l-.108-.24085s-6.82814,12.68083-20.48442,12.68083l4.87724-4.87724s-16.90968,6.91759-26.16672,8.47162a5.88789,5.88789,0,0,0-3.26883,9.88691q.08431.0872.17209.175c5.85269,5.85269,17.55808,19.509,10.72994,30.23891S405.833,414.534,405.833,414.534L395.103,408.68134,390.2258,405.755v3.90179l-25.36167-2.92634s-6.82814-.97545,7.80359-17.55808c0,0,3.86375-6.43958,2.17333-11.99363a28.01508,28.01508,0,0,1-1.06491-13.10175C377.054,345.7905,389.91464,309.4347,439.97368,332.59634Z",
    transform: "translate(-202 -189.61991)",
    fill: "#2f2e41"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "150.319 326.367 142.161 347.113 152.322 330.45 150.319 326.367",
    opacity: 0.2
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M338.40305,487.61949,373.629,559.42618l83.32286,11.51617s29.80655,49.45178,36.58076,39.29046-25.742-52.83889-25.742-52.83889l-79.93575-23.70976-25.0646-52.16146Z",
    transform: "translate(-202 -189.61991)",
    fill: "#9f616a"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M439.86518,453.4827l35.22592,71.80669L558.414,536.80556s50.66939,16.56795,57.4436,6.40662-46.60485-19.95505-46.60485-19.95505L489.317,499.54737l-25.0646-52.16146Z",
    transform: "translate(-202 -189.61991)",
    fill: "#9f616a"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M353.645,417.50636s-16.93554,4.742-21.00007,20.32264,11.51617,98.90356,11.51617,98.90356,17.27425-49.79049,26.75815-46.40338C370.91928,490.32918,371.93542,424.958,353.645,417.50636Z",
    transform: "translate(-202 -189.61991)",
    fill: "#3f3d56"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M426.46786,409.716s9.4839-7.45164,17.613,2.70968,44.37111,70.11314,44.37111,70.11314-53.17759-5.08066-53.17759-1.69355Z",
    transform: "translate(-202 -189.61991)",
    fill: "#3f3d56"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M708.074,189.61991a6.19353,6.19353,0,0,0-6.187,6.187V438.32951a6.19353,6.19353,0,0,0,6.187,6.187h283.2711a6.19352,6.19352,0,0,0,6.187-6.187V195.80693a6.19352,6.19352,0,0,0-6.187-6.187Z",
    transform: "translate(-202 -189.61991)",
    fill: "#e6e6e6"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M747.36034,335.5956a2.72021,2.72021,0,0,0,0,5.33106H954.60605a2.72021,2.72021,0,0,0,0-5.33106Z",
    transform: "translate(-202 -189.61991)",
    fill: "#fff"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M744.813,367.26914a2.7202,2.7202,0,0,0,0,5.33105H952.05874a2.7202,2.7202,0,0,0,0-5.33105Z",
    transform: "translate(-202 -189.61991)",
    fill: "#fff"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M747.36034,398.94267a2.72021,2.72021,0,0,0,0,5.33106H954.60605a2.72021,2.72021,0,0,0,0-5.33106Z",
    transform: "translate(-202 -189.61991)",
    fill: "#fff"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M747.36034,229.86271a2.72111,2.72111,0,0,0,0,5.33253H954.60605a2.72111,2.72111,0,0,0,0-5.33253Z",
    transform: "translate(-202 -189.61991)",
    fill: "#fff"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M744.813,261.53624a2.72111,2.72111,0,0,0,0,5.33254H952.05874a2.72111,2.72111,0,0,0,0-5.33254Z",
    transform: "translate(-202 -189.61991)",
    fill: "#fff"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M747.36034,293.20978a2.72111,2.72111,0,0,0,0,5.33253H954.60605a2.72111,2.72111,0,0,0,0-5.33253Z",
    transform: "translate(-202 -189.61991)",
    fill: "#fff"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M581.45915,288.7934a6.19353,6.19353,0,0,0-6.187,6.187V537.503a6.19353,6.19353,0,0,0,6.187,6.187h283.2711a6.19352,6.19352,0,0,0,6.187-6.187V294.98042a6.19352,6.19352,0,0,0-6.187-6.187Z",
    transform: "translate(-202 -189.61991)",
    fill: "#edd84f"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M620.7455,434.76909a2.72021,2.72021,0,0,0,0,5.33106H827.99121a2.72021,2.72021,0,0,0,0-5.33106Z",
    transform: "translate(-202 -189.61991)",
    fill: "#fff"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M618.19819,466.44263a2.72021,2.72021,0,0,0,0,5.33106H825.4439a2.72021,2.72021,0,0,0,0-5.33106Z",
    transform: "translate(-202 -189.61991)",
    fill: "#fff"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M620.7455,498.11617a2.72021,2.72021,0,0,0,0,5.33106H827.99121a2.72021,2.72021,0,0,0,0-5.33106Z",
    transform: "translate(-202 -189.61991)",
    fill: "#fff"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M620.7455,329.0362a2.72111,2.72111,0,0,0,0,5.33253H827.99121a2.72111,2.72111,0,0,0,0-5.33253Z",
    transform: "translate(-202 -189.61991)",
    fill: "#fff"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M618.19819,360.70974a2.72111,2.72111,0,0,0,0,5.33253H825.4439a2.72111,2.72111,0,0,0,0-5.33253Z",
    transform: "translate(-202 -189.61991)",
    fill: "#fff"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M620.7455,392.38327a2.72111,2.72111,0,0,0,0,5.33254H827.99121a2.72111,2.72111,0,0,0,0-5.33254Z",
    transform: "translate(-202 -189.61991)",
    fill: "#fff"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 664.95495,
    cy: 95.12109,
    r: 72.33166,
    fill: "#3f3d56"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "674.455 97.658 674.455 60.764 655.455 60.764 655.455 97.658 646.584 97.658 655.769 113.568 664.955 129.478 674.141 113.568 683.326 97.658 674.455 97.658",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTip7);
export default __webpack_public_path__ + "static/media/tip7.957e3b7d6f8920f5a79023285bec4b3e.svg";
export { ForwardRef as ReactComponent };